import React, { useCallback } from 'react';
import type { PressableProps, ViewProps } from 'react-native';
import { Pressable, StyleSheet, View } from 'react-native';

import type { SweetpassHomeActionCardItem } from '../../hooks';
import { VALID_ACTIONS_FOR_SWEETPASS_ACTIONS_RAIL } from '../../hooks';
import { SweetpassHomeActionCardLayout } from './SweetpassHomeActionCardLayout';

export const SweetpassHomeActionCard = (
  props: SweetpassHomeActionCardProps,
) => {
  const { testID, actionHandler, action, ...layoutProps } = props;

  const pressHandler = useCallback(() => {
    if (!action) return;
    actionHandler(action);
  }, [actionHandler, action]);

  return (
    <PressableWrapper
      testID={testID}
      onPress={action ? pressHandler : undefined}
    >
      <SweetpassHomeActionCardLayout
        {...layoutProps}
        testID={testID?.concat('.card')}
        hasAction={
          action ? VALID_ACTIONS_FOR_SWEETPASS_ACTIONS_RAIL.has(action) : false
        }
      />
    </PressableWrapper>
  );
};

const PressableWrapper = ({
  testID,
  onPress,
  children,
}: PressableWrapperProps) =>
  onPress ? (
    <Pressable
      testID={testID}
      accessibilityRole="button"
      onPress={onPress}
      style={styles.pressable}
    >
      {children}
    </Pressable>
  ) : (
    <View testID={testID}>{children}</View>
  );

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  pressable: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type SweetpassHomeActionCardProps = {
  readonly actionHandler: (action: string) => void;
} & Omit<SweetpassHomeActionCardItem, 'id'> &
  ViewProps;

type PressableWrapperProps = Pick<ViewProps, 'testID' | 'children'> &
  Pick<PressableProps, 'onPress'>;
